var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-40 0 560.12 131.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .base-1 {\n        isolation: isolate;\n      }\n\n      .base-2, .base-3 {\n        fill: #7d7d93;\n      }\n\n      .base-12, .base-14, .base-3 {\n        mix-blend-mode: multiply;\n      }\n\n      .base-10, .base-14, .base-16, .base-3 {\n        opacity: 0.3;\n      }\n\n      .base-4 {\n        fill: #67677c;\n      }\n\n      .base-5 {\n        opacity: 0.9;\n        fill: url(#linear-gradient);\n      }\n\n      .base-6 {\n        fill: #1a1a26;\n        opacity: 0.25;\n      }\n\n      .base-7 {\n        opacity: 0.2;\n      }\n\n      .base-11, .base-8 {\n        fill: #f2f2f2;\n      }\n\n      .base-9 {\n        opacity: 0.7;\n      }\n\n      .base-11, .base-15 {\n        opacity: 0.1;\n      }\n\n      .base-12, .base-15, .base-16, .base-17 {\n        fill: none;\n      }\n\n      .base-12 {\n        stroke: #1b1464;\n        stroke-miterlimit: 10;\n        stroke-width: 10px;\n        opacity: 0.15;\n      }\n\n      .base-13 {\n        fill: #87879b;\n      }\n\n      .base-14 {\n        fill: #565668;\n      }\n\n      .base-15 {\n        stroke: #fff;\n      }\n\n      .base-15, .base-16, .base-17 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n\n      .base-16, .base-17 {\n        stroke: #1f1f2d;\n      }\n\n      .base-18 {\n        fill: #1f1f2d;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 26.71,
    y1: 65.98,
    x2: 548.36,
    y2: 65.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7d7d93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#72728a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#676780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#60607a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5e5e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#60607a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#676780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#72728a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d7d93"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "base-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Support"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "base-2",
    points: "507.65 130.97 556.94 130.97 560.12 120.14 511.51 91.91 507.65 130.97"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "base-3",
    cx: 540.35,
    cy: 120.67,
    r: 3.04
  })), /*#__PURE__*/React.createElement("g", {
    id: "Support-2",
    "data-name": "Support"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "base-2",
    points: "52.47 130.97 3.18 130.97 0 120.14 48.6 91.91 52.47 130.97"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "base-3",
    cx: 19.76,
    cy: 120.67,
    r: 3.04
  }))), /*#__PURE__*/React.createElement("path", {
    className: "base-4",
    d: "M493.71,18.67,475.71,1h-93l-8.91,8.92L352.3,53.57,343.63,59H216.48l-8.66-5.4L186.36,9.92,177.44,1h-93l-18,17.67-25,101.47L52.24,131H507.88l10.83-10.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "base-5",
    d: "M493.71,18.67,475.71,1h-93l-8.91,8.92L352.3,53.57,343.63,59H216.48l-8.66-5.4L186.36,9.92,177.44,1h-93l-18,17.67-25,101.47L52.24,131H507.88l10.83-10.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "base-6",
    points: "41.41 120.14 518.71 120.14 507.88 130.97 52.23 130.97 41.41 120.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "base-2",
    d: "M475.71,1h-93l-8.91,8.92L352.3,53.57,343.63,59H216.48l-8.66-5.4L186.36,9.92,177.44,1h-93l-18,17.67h96.72l6.17,3.49,26.84,49.56,6.16,3.48H357.54L364,71.39l26.86-48.91,6.44-3.81h96.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "base-6",
    points: "323.29 86.73 236.82 86.73 221.47 120.14 221.47 130.97 338.65 130.97 338.65 120.14 323.29 86.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "base-6",
    points: "236.82 86.73 238.88 91.91 321.24 91.91 323.29 86.73 236.82 86.73"
  }), /*#__PURE__*/React.createElement("g", {
    className: "base-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "base-8",
    points: "163.13 18.67 177.44 1 186.36 9.92 169.29 22.16 163.13 18.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "base-8",
    points: "207.82 53.57 196.14 71.72 202.3 75.2 216.48 58.97 207.82 53.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "base-8",
    points: "343.63 58.97 352.3 53.57 363.97 71.39 357.54 75.2 343.63 58.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "base-8",
    points: "373.76 9.92 382.67 1 397.27 18.67 390.83 22.48 373.76 9.92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Highlights"
  }, /*#__PURE__*/React.createElement("g", {
    className: "base-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "base-8",
    d: "M210,75.2c5.84-.62,11.68-1.06,17.51-1.51H332.6c5.84.46,11.68.9,17.52,1.5-5.84.6-11.68,1-17.52,1.5H245l-17.52,0C221.68,76.27,215.84,75.83,210,75.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "base-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "base-8",
    d: "M72.18,18.67c3.73-.62,7.47-1.06,11.2-1.51h67.24c3.73.46,7.47.9,11.2,1.5-3.73.61-7.47,1-11.2,1.5h-56l-11.21,0C79.65,19.74,75.91,19.3,72.18,18.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "base-8",
    d: "M405.35,18.67c3.44-.62,6.88-1.06,10.32-1.51h61.95c3.44.46,6.88.9,10.32,1.5-3.44.61-6.88,1-10.32,1.5H426l-10.33,0C412.23,19.74,408.79,19.3,405.35,18.67Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Highlights-2",
    "data-name": "Highlights"
  }, /*#__PURE__*/React.createElement("path", {
    className: "base-11",
    d: "M67.79,25.9,47.44,113.23a3.78,3.78,0,0,0,3.68,4.64h7.69a3.79,3.79,0,0,0,3.69-4.61c-1.4-6.38-2.82-19.68,1.37-41.79C68,49.86,74.53,35.8,78.59,28.66A3.78,3.78,0,0,0,75.33,23l-3.84,0A3.79,3.79,0,0,0,67.79,25.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "base-11",
    d: "M492.33,25.9l20.35,87.33a3.78,3.78,0,0,1-3.68,4.64h-7.69a3.78,3.78,0,0,1-3.69-4.61c1.4-6.38,2.82-19.68-1.37-41.79-4.09-21.61-10.66-35.67-14.72-42.81A3.78,3.78,0,0,1,484.79,23l3.84,0A3.79,3.79,0,0,1,492.33,25.9Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "base-12",
    x1: 260.09,
    y1: 81.79,
    x2: 300.03,
    y2: 81.79
  })), /*#__PURE__*/React.createElement("g", {
    id: "Support-3",
    "data-name": "Support"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "base-13",
    points: "321.24 91.91 238.88 91.91 221.47 130.97 338.65 130.97 321.24 91.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "base-4",
    points: "307.01 117.87 253.1 117.87 247.26 130.97 312.85 130.97 307.01 117.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "base-2",
    points: "238.88 91.91 253.1 117.87 307.01 117.87 321.24 91.91 238.88 91.91"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "base-14",
    cx: 258.88,
    cy: 109.32,
    rx: 3.76,
    ry: 2.12
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "base-14",
    cx: 301.24,
    cy: 109.32,
    rx: 3.76,
    ry: 2.12
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "base-14",
    cx: 240.73,
    cy: 120.67,
    rx: 3.76,
    ry: 2.12,
    transform: "translate(1.52 244.32) rotate(-53.96)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "base-14",
    cx: 319.39,
    cy: 120.67,
    rx: 2.12,
    ry: 3.76,
    transform: "translate(-9.86 211.02) rotate(-36.04)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "base-15",
    points: "87.35 96.85 99.77 109.26 180.28 109.26 192.81 121.79 194.14 129.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "base-16",
    points: "86.82 94.97 97.35 18.67 107.23 1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "base-15",
    points: "97.76 44.72 101.35 18.67 110.73 1.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "base-15",
    x1: 90.82,
    y1: 94.97,
    x2: 93.45,
    y2: 75.91
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "base-16",
    points: "92.14 95.9 101.42 105.18 181.28 105.18 195.26 119.16 197.01 129.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "base-17",
    points: "109.29 1 99.41 18.67 88.82 95.32 100.77 107.26 180.94 107.26 194.26 120.59 196.14 130.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "base-15",
    points: "104 53.57 101.42 76.75 92.71 81.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "base-18",
    d: "M95.58,46.39l6.85,6.26a2.44,2.44,0,0,1,.79,2.1l-2.29,20a2.45,2.45,0,0,1-1.31,1.9l-8.86,4.66Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "base-16",
    x1: 97.47,
    y1: 46.81,
    x2: 103.24,
    y2: 52.26
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBase);
export default __webpack_public_path__ + "static/media/Base.65b29f27cbc37a9b90f678674fd56ca5.svg";
export { ForwardRef as ReactComponent };